import React, {Component} from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import {enableUniqueIds} from '@cred/shared/unique-id'
import Font from '@cred/react-font'
import {Field} from 'redux-form'
import emitOnChange from '@cred/react-analytics/hoc/emitOnChange'
import styles from './styles.module.scss'

const getCredible3IconClass = ({input, hideAutoAdvance}) => {
  const {checked} = input

  if (checked) {
    return `cred-icon icon-check-circle ${styles.checkCircle}`
  }

  // Forms that do not autoadvance on selection (e.g., you must click a submit button to continue)
  // Should not show the autoadvance chevron
  if (hideAutoAdvance) {
    return ''
  }

  return 'cred-icon icon-chevron-right'
}

/**
 * @deprecated Radio is deprecated, please use @cred/react-basic-form-fields/Radio or @cred/react-basic-form-fields/[reduxForm|hookForm]/Radio instead.
 */
class Radio extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    withBorder: PropTypes.bool,
    radioType: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    description: PropTypes.string,
    showBlockLabel: PropTypes.bool,
    hideAutoAdvance: PropTypes.bool,
    appearance: PropTypes.string,
  }
  static defaultProps = {
    withBorder: false,
    radioType: 'radio',
    showBlockLabel: false,
    hideAutoAdvance: false,
    appearance: null,
  }

  static displayName = 'Radio'

  constructor(props) {
    super(props)
    enableUniqueIds(this)
  }

  render() {
    const {id, ...props} = this.props

    return (
      <Field type="radio" component={radioButtonWithAnalytics} id={id || this.nextUniqueId()} {...props}/>
    )
  }
}

const radioInput = field => {
    const {theme, radioType, withBorder, className, input, hideAutoAdvance, appearance} = field
    const credible3IconClassName = getCredible3IconClass({input, hideAutoAdvance})

    return (
      <div className={[styles[radioType], className, field.description ? styles.withDescription : ''].join(' ')}>
        <input
          hidden
          type="radio"
          id={field.id}
          disabled={field.disabled}
          {...field.input}
        />
        <div
          className={cx(styles.radioInputWrapper, {
            [styles.withBorder]: !!withBorder,
            [styles[`${appearance}LabelWrapper`]]: !!appearance
          })}
          ref={field.forwardRef}
          key={field.id}
          onKeyPress={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              const {input: {value, onChange}} = field

              onChange(value)
            }
          }}
        >

          {field.radioType === 'checkbox' ?
            <Font element="label" htmlFor={field.id}>
              <span className={styles.checkboxBox}>
                <span className={styles.checkboxIcon}>
                  <i className="cred-icon icon-check"/>
                </span>
              </span>
              <span className={[styles.checkboxLabel, 'hidden-xs', 'hidden-sm'].join(' ')}>
                {field.label}
              </span>
              <span className={[styles.checkboxLabel, 'hidden-md', 'hidden-lg', 'hidden-xl'].join(' ')}>
                {field.mobileLabel || field.label}
              </span>
            </Font>
            :
            theme === 'credible3' || appearance === 'button' ?
              <label className={cx({
                [styles[`${appearance}Label`]]: !!appearance
              })} htmlFor={field.id} role="radio" tabIndex={0} aria-checked={field.input.checked}>
                <div>
                  <Font element="span" weight="semiBold" className={styles.radioLabel}>{field.label}</Font>
                  <Font element="span" type="bodySmall" className={styles.description}>{field.description}</Font>
                </div>
                <i
                  className={credible3IconClassName}
                />
              </label>
              :
              <Font element="label" htmlFor={field.id} className={field.showBlockLabel ? styles.blockLabel : ''} role="radio" tabIndex={0} aria-checked={field.input.checked}>
                <span className={styles.radioBox}>
                  <span className={styles.radioIcon}/>
                </span>
                <div>
                  <span className={[styles.radioLabel, field.showBlockLabel ? styles.blockLabel : ''].join(' ')}>{field.label}</span>
                </div>
              </Font>
          }
        </div>
      </div>
    )
  },
  radioButtonWithAnalytics = /*#__PURE__*/ emitOnChange(radioInput)

export {Radio as RadioNoHoc, radioInput, getCredible3IconClass}

export default /*#__PURE__*/ Radio
